
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'itemsContainer': {'height': `100%`,'width': `80%`,'margin': `16px 0px`,},'itemContainer': {'display': `flex`,'margin': `16px 0px`,},'itemImage': {'width': `60px`,'height': `auto`,'marginRight': `8px`,'borderRadius': `0%`,},'textContainer': {'display': `flex`,'flexDirection': `column`,'justifyContent': `center`,},'itemName': {'fontSize': `12px`,'fontFamily': `'Lemon-Regular', sans-serif`,'fontWeight': `bold`,'color': `#ffffff`,},'itemQuantity': {'fontSize': `12px`,'fontStyle': `italic`,'color': `#ffffff`,},'title': {'fontFamily': `'Lemon-Regular', sans-serif`,'fontSize': `16px`,'fontWeight': `bold`,'margin': `16px 0px`,'color': `#ffffff`,},
        
      };
    };
  